<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-main">
        <div class="footer-brand">
          <router-link :to="{ name: 'public-components' }" class="footer-logo-wrap">
            <img
              src="@/assets/bjp/Logo-oficial.png"
              alt="Ministerio de Educación"
              class="footer-logo"
            />
          </router-link>
          <p>
            Portal oficial de información y consulta del Bono Juancito Pinto,
            gestión 2026.
          </p>
        </div>

        <nav class="footer-nav" aria-label="Navegación del pie de página">
          <span>Portal</span>
          <router-link :to="{ name: 'public-components' }">Inicio</router-link>
          <router-link :to="{ name: 'public-search' }">Consultar beneficio</router-link>
          <router-link :to="{ name: 'public-info' }">Requisitos</router-link>
          <router-link :to="{ name: 'public-entities' }">Entidades autorizadas</router-link>
        </nav>

        <div class="footer-contact">
          <span>Atención ciudadana</span>
          <a href="tel:800103223" class="footer-phone">800 10 3223</a>
          <small>Línea gratuita de orientación</small>
          <a
            href="https://www.minedu.gob.bo/"
            target="_blank"
            rel="noopener"
            class="minedu-link"
          >
            Visitar minedu.gob.bo <i class="bx bx-link-external"></i>
          </a>
        </div>
      </div>

      <div class="footer-bottom">
        <span>© {{ year }} Ministerio de Educación</span>
        <span>Estado Plurinacional de Bolivia</span>
      </div>
    </div>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear();
</script>

<style scoped>
.site-footer {
  position: relative;
  padding: 4rem 0 1.5rem;
  overflow: hidden;
  color: #ffffff;
  border-top: 1px solid rgba(230, 203, 114, 0.18);
  background: #062f36;
}

.site-footer::before {
  position: absolute;
  top: -16rem;
  right: -12rem;
  width: 32rem;
  height: 32rem;
  content: "";
  border: 1px solid rgba(230, 203, 114, 0.1);
  border-radius: 50%;
}

.footer-main {
  position: relative;
  display: grid;
  grid-template-columns: minmax(260px, 1.5fr) minmax(180px, 0.75fr) minmax(220px, 0.85fr);
  padding-bottom: 3rem;
  gap: clamp(2rem, 7vw, 7rem);
}

.footer-logo-wrap {
  display: inline-block;
  width: min(100%, 250px);
  padding: 0;
  background: transparent;
}

.footer-logo {
  display: block;
  width: 100%;
  height: auto;
}

.footer-brand p {
  max-width: 430px;
  margin: 1.25rem 0 0;
  color: #ffffff;
  font-size: 0.84rem;
  line-height: 1.7;
}

.footer-nav,
.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer-nav > span,
.footer-contact > span {
  margin-bottom: 1rem;
  color: #ffffff;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.footer-nav a {
  padding: 0.28rem 0;
  color: #ffffff;
  font-size: 0.82rem;
}

.footer-nav a:hover,
.minedu-link:hover {
  color: #ffffff;
  text-decoration: none;
}

.footer-phone {
  color: #ffffff;
  font-size: 1.8rem;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.footer-phone:hover {
  color: #ffffff;
  text-decoration: none;
}

.footer-contact small {
  margin-top: 0.25rem;
  color: #ffffff;
  font-size: 0.72rem;
}

.minedu-link {
  display: inline-flex;
  align-items: center;
  margin-top: 1.2rem;
  color: #ffffff;
  font-size: 0.78rem;
  gap: 0.35rem;
}

.footer-bottom {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 1.35rem;
  color: #ffffff;
  font-size: 0.7rem;
  border-top: 1px solid rgba(230, 203, 114, 0.12);
}

@media (max-width: 767px) {
  .site-footer {
    padding-top: 3rem;
  }
  .footer-main {
    grid-template-columns: 1fr;
    gap: 2.2rem;
  }
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
  }
}
</style>
